export default "__VITE_ASSET__CpvskCqI__"